module.exports = __webpack_public_path__ + "static/media/2020.8.7公益书法班.b3179c92.jpg";